<app-loader
	[enableCircle]="true"
	[isActive]="loading()"
	[isAfterViewInit]="false"
></app-loader>
<h1
	class="headline"
	matDialogTitle
>
	<div class="flex flex-row items-center justify-start space-x-2">
		<button
			(click)="prevStep()"
			[disabled]="loading() || stepIndex() < 1"
			[matTooltip]="'paginator.previousPage' | translate"
			class="mat-button-square !rounded-lg"
			mat-button
			tabindex="-1"
		>
			<mat-icon>chevron_left</mat-icon>
		</button>
		@switch (stepIndex()) { @case (0) {
		<div class="flex flex-col">
			<div>{{ 'time.pick-project' | translate }}</div>
			<div class="text-muted text-sm">{{ 'time.projects-tasks-based-on-user' | translate }}</div>
		</div>
		} @case (1) {
		<div class="flex flex-col">
			<div>{{ 'time.pick-task' | translate }}</div>
			@if ((selected.value$ | async)?.project; as project) {
			<div class="flex items-center space-x-1">
				<div
					[matTooltip]="'project.color' | translate"
					[style.backgroundColor]="color"
					*ngIf="project.color as color"
					class="h-2 w-2 self-center rounded-full"
				></div>
				<div class="text-muted text-sm">{{ project | defaultEntityTranslate: 'project' : 'project.none' }}</div>
			</div>
			}
		</div>
		} }
		<div class="flex-auto"></div>
		<button
			mat-icon-button
			matDialogClose
			tabindex="-1"
		>
			<mat-icon>close</mat-icon>
		</button>
	</div>
</h1>
<mat-dialog-content class="!m-0 !px-0">
	<tg-plain-stepper
		(selectedIndexChange)="selectedIndexChange($event)"
		[selectedIndex]="stepIndex()"
	>
		<cdk-step>
			<tg-project-list
				(entityChange)="onSelectProject($event)"
				[selectedEntity]="selected.value$ | async"
				[suggestProjectByName]="(selected.value$ | async)?.title"
				[userId]="userId"
				class="max-h-inherit"
			></tg-project-list>
		</cdk-step>
		<cdk-step>
			<tg-task-list
				(selectedEntityChange)="onSelectProject($event, true)"
				[selectedEntity]="selected.value$ | async"
				[userId]="userId"
			></tg-task-list>
		</cdk-step>
	</tg-plain-stepper>
</mat-dialog-content>
<mat-dialog-actions
	align="end"
	class="mx-6 !mb-0 flex items-center space-x-4"
>
	@switch (stepIndex()) { @case (0) {
	<button
		(click)="createProject()"
		[disabled]="!(canManageProject$ | async)"
		mat-button
	>
		{{ 'project.create' | translate }}
	</button>
	} @case (1) {
	<button
		(click)="createTask()"
		[disabled]="!(canCreateTask$ | async)"
		mat-button
	>
		{{ 'task.add' | translate }}
	</button>
	} }
</mat-dialog-actions>
